function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m496.602 74.962c-8.575 9.478-20.884 19.139-36.684 28.82-3.369 2.07-6.901 4.14-10.594 6.211-13.06 7.306-27.825 14.481-43.909 21.341-4.8 2.05-9.174 3.836-12.959 5.338-8.92 3.531-14.603 5.52-14.938 5.632-.812.284-1.654.416-2.496.416-1.401 0-2.791-.385-4.008-1.137-1.959-1.208-3.257-3.237-3.542-5.51-1.187-9.356-1.055-18.976.375-28.586.619-4.161 4.506-7.012 8.646-6.403 4.161.619 7.032 4.496 6.413 8.656-.741 4.921-1.076 9.843-1.015 14.704 1.542-.589 3.257-1.258 5.114-1.989 3.653-1.461 7.854-3.176 12.431-5.124 15.587-6.647 29.865-13.578 42.448-20.621 3.176-1.786 6.627-3.785 10.178-5.977 23.198-14.299 51.256-36.542 43.189-56.889-3.948-9.965-10.909-15.536-20.671-16.571-22.295-2.365-53.905 18.012-73.622 47.421l-5.886 9.985c-2.131 3.623-6.799 4.831-10.422 2.699-3.623-2.131-4.83-6.799-2.699-10.422l5.997-10.178c.071-.122.152-.244.233-.366 22.995-34.421 60.014-57.254 88.002-54.28 15.394 1.634 27.186 10.909 33.214 26.1 5.968 15.039 1.655 30.768-12.795 46.73z",
    fill: "#e12c45",
    "data-original": "#db5c6e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.021 142.723c-1.401 0-2.794-.387-4.013-1.144-1.949-1.21-3.249-3.235-3.538-5.511-1.185-9.357-1.059-18.974.376-28.582.621-4.158 4.506-7.018 8.651-6.403 4.157.621 7.024 4.495 6.404 8.652-.735 4.924-1.07 9.844-1.005 14.71 4.608-1.773 10.655-4.18 17.546-7.117 15.584-6.641 29.863-13.578 42.44-20.62 23.924-13.403 62.672-39.394 53.369-62.863-3.95-9.963-10.905-15.54-20.668-16.576-22.301-2.364-53.91 18.012-73.629 47.421l-5.881 9.991c-2.134 3.622-6.797 4.828-10.42 2.698-3.622-2.132-4.83-6.797-2.698-10.42l5.993-10.18c.073-.124.151-.247.231-.367 22.996-34.423 60.018-57.255 88.01-54.28 15.39 1.633 27.186 10.903 33.213 26.103 5.961 15.038 1.654 30.759-12.802 46.728-10.405 11.495-26.312 23.279-47.279 35.026-13.054 7.308-27.827 14.488-43.91 21.342-16.07 6.851-27.418 10.806-27.893 10.971-.813.282-1.657.421-2.497.421z",
    fill: "#e12c45",
    "data-original": "#db5c6e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m452.38 267.833c4.094-4.806 6.94-10.567 8.21-16.747 4.506-21.943 10.692-78.529-19.285-159.995-3.795-10.323-11.941-18.469-22.264-22.264-81.466-29.977-138.053-23.79-159.989-19.278-6.187 1.262-11.948 4.108-16.747 8.21-89.758 76.562-157.616 143.653-233.111 230.768-11.795 13.608-12.304 33.703-1.137 47.827 48.796 61.685 104.036 116.926 165.722 165.722 14.124 11.167 34.218 10.658 47.826-1.137 87.122-75.489 154.206-143.354 230.775-233.106zm-98.184-111.897c-11.501-11.501-11.501-30.152 0-41.653 11.502-11.502 30.152-11.502 41.654 0s11.501 30.152 0 41.654c-11.502 11.501-30.153 11.501-41.654-.001z",
    fill: "#ffc747",
    "data-original": "#ffd064",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.05 49.549c-6.19 1.267-11.947 4.109-16.746 8.208-89.766 76.563-157.616 143.661-233.118 230.77-11.792 13.605-12.297 33.709-1.133 47.829.845 1.071 1.699 2.142 2.544 3.203-2.008-10.803 1.565-23.193 10.227-32.967 78.128-88.118 147.44-156.761 238.134-236.105 4.841-4.253 10.495-7.395 16.427-9.084 16.756-4.81 54.348-12.4 106.553-4.315-61.557-16.304-104.453-11.329-122.888-7.539z",
    fill: "#ffc250",
    "data-original": "#ffc250",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#db5c6e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m121.94 336.121c-1.349-1.349-2.458-2.984-3.226-4.862-3.092-7.564.534-16.202 8.098-19.294l182.011-74.401c7.563-3.091 16.199.531 19.294 8.097 3.092 7.564-.534 16.202-8.098 19.294l-182.011 74.401c-5.687 2.325-11.98.853-16.068-3.235z",
    fill: "#e12c45",
    "data-original": "#db5c6e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.113 236.432c-18.878-18.878-17.149-51.322 3.853-72.325s53.447-22.73 72.325-3.853c18.878 18.878 17.15 51.323-3.852 72.325s-53.448 22.731-72.326 3.853zm55.252-55.253c-7.215-7.215-21.172-5.451-30.476 3.853s-11.068 23.26-3.853 30.476c7.216 7.216 21.172 5.452 30.476-3.852 9.305-9.305 11.069-23.261 3.853-30.477z",
    fill: "#e12c45",
    "data-original": "#db5c6e",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.047 417.68c-18.878-18.878-17.15-51.323 3.852-72.325s53.447-22.73 72.325-3.852 17.149 51.322-3.853 72.324c-21.001 21.002-53.446 22.73-72.324 3.853zm55.253-55.253c-7.216-7.216-21.172-5.452-30.476 3.852s-11.068 23.26-3.852 30.476c7.215 7.215 21.172 5.451 30.476-3.853 9.303-9.304 11.067-23.26 3.852-30.475z",
    fill: "#e12c45",
    "data-original": "#db5c6e",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m375.022 172.161c-9.491 0-18.983-3.613-26.209-10.839-14.452-14.452-14.452-37.966 0-52.418 7.001-7.001 16.309-10.856 26.21-10.856 9.9 0 19.207 3.855 26.209 10.856 14.452 14.452 14.452 37.966 0 52.418-7.227 7.226-16.718 10.839-26.21 10.839zm.001-58.891c-5.835 0-11.32 2.272-15.446 6.398-8.518 8.517-8.518 22.375 0 30.891 8.518 8.518 22.375 8.516 30.89 0 8.518-8.517 8.518-22.375 0-30.891-4.125-4.126-9.61-6.398-15.444-6.398z",
    fill: "#ffc250",
    "data-original": "#ffc250",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m459.918 103.782c-3.369 2.07-6.901 4.14-10.594 6.211-13.06 7.306-27.825 14.481-43.909 21.341-4.8 2.05-9.174 3.836-12.959 5.338-2.72-4.232-4.607-9.052-5.449-14.217 3.653-1.461 7.854-3.176 12.431-5.124 15.587-6.647 29.865-13.578 42.448-20.621 3.176-1.786 6.627-3.785 10.178-5.977 3.449 3.733 6.139 8.158 7.854 13.049z",
    fill: "#e12c45",
    "data-original": "#db5c6e",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountTag);
export default __webpack_public_path__ + "static/media/discount-tag.c7e14a719adb3fc69ddf2dfb65c9cdd3.svg";
export { ForwardRef as ReactComponent };